import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: (hasMargin, theme) => ({
    backgroundColor: theme.colors.backgroundColorTwo,
    marginBottom: hasMargin ? 5 : 0,
  }),
  rowContainer: {
    padding: 20,
  },
  rowItem: {
    flexDirection: 'row',
    paddingVertical: 10,
    alignItems: 'center',
  },
  title: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    marginLeft: 16,
  }),
  detail: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    marginLeft: 5,
  }),
  extraContentContainer: {
    backgroundColor: Colors.white,
    paddingTop: 16,
  },
  extraContentTitle: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
    marginLeft: 16,
  },
  iconsContainer: {
    flexDirection: 'row',
    marginTop: 16,
    borderBottomColor: Colors.lightGrayTwo,
    borderBottomWidth: 1,
    paddingBottom: 15,
    paddingHorizontal: 16,
  },
  icon: {
    marginRight: 20,
  },
  buttonContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    padding: 16,
  }),
  infoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  infoText: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
  },
  infoButton: {
    marginLeft: 10,
  },
})

export default styles
